{
  "button-bar-for-continue-booking": {
    "button": {
      "cancel": "Zrušit",
      "continue": "Pokračovat"
    },
    "text": {
      "continue-booking": "Vaše rezervace ještě není dokončena. Chcete pokračovat?"
    }
  }
}
